import { Badge } from '@/components/ui/badge';
import type { Investigation } from '@/types';

// Three-state notary indicator shared across admin/CS lists and detail views:
//   notaryCompletedAt set → "Notarised ✓ {date}"
//   notaryUser set, not completed → "Assigned — pending"
//   no notaryUser → "Not assigned"
export default function NotaryStatusBadge({ investigation }: { investigation: Investigation }) {
    if (investigation.notaryCompletedAt) {
        const when = new Date(investigation.notaryCompletedAt);
        const label = Number.isNaN(when.getTime()) ? '' : ` ${when.toLocaleDateString()}`;
        return (
            <Badge
                variant="outline"
                className="bg-green-50 text-green-700 border-green-100 px-3 py-1 rounded-lg font-medium whitespace-nowrap"
            >
                Notarised ✓{label}
            </Badge>
        );
    }

    if (investigation.notaryUser) {
        return (
            <Badge
                variant="outline"
                className="bg-amber-50 text-amber-700 border-amber-100 px-3 py-1 rounded-lg font-medium whitespace-nowrap"
            >
                Assigned — pending
            </Badge>
        );
    }

    return <span className="text-gray-400 text-sm">Not assigned</span>;
}
